var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-widget',{staticClass:"px-0",attrs:{"title":_vm.titulo,"content-bg":"white"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('e-chart',{attrs:{"path-option":[
            ['dataset.source', _vm.res],
            ['legend.bottom', '0'],
            [
              'color',
              [_vm.color.lightBlue.base, _vm.color.orange.base, _vm.color.grey.base],
            ],
            ['xAxis.show', false],
            ['yAxis.show', false],
            ['series[0].type', 'pie'],
            ['series[0].avoidLabelOverlap', true],
            ['series[0].radius', ['50%', '70%']],
          ],"height":"400px","width":"100%"}})],1)]),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('u',{staticClass:"blue--text",on:{"click":function($event){return _vm.ViewByRegion(_vm.titleIn, _vm.nivelFiltro, _vm.fechaProgreso)}}},[_vm._v("Ver por region")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }